import { Spinner, styled } from '@volkswagen-onehub/components-core';
import React from 'react';

const SpinnerWrapper = styled.div`
    position: fixed;
    top: 15%;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    height: 80vh;
    display: grid;
    justify-content: center;
    align-content: center;
    pointer-events: none;
`;

const Loading  = () => {

    return (
        <SpinnerWrapper>
            <Spinner variant="x-large" />
        </SpinnerWrapper>
    );
}

export default Loading;
